import React from "react";

const SwitchButton = (props) => {

  return (
     <div style={{ display: "flex", alignItems: "left", gap: "12px",margin: "10px" }}>
                <label style={{marginRight: props.topLabel?"0px":"10px", color: props.topLabel?"#000":"#726e6e",maxWidth:"180px",position: props.topLabel?'absolute':"relative",zIndex:"99", marginLeft: props.topLabel?"15px":"0px", top:props.topLabel?"1px":"", fontSize: props.topLabel?"0.6em":"auto",fontWeight:props.topLabel?"700":"300", letterSpacing:props.topLabel?"1.5px":"1"   }}>{props.label}</label>
                <div
                  style={{
                    position: "relative",
                    width: "60px",
                    height: "30px",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={props.userInfo && !!props.userInfo[props.keyName]}
                    onChange={() =>
                      props.onChange(props.keyName)
                    }
                    style={{
                      opacity: 0,
                      width: "100%",
                      height: "100%",
                      position: "absolute",
                      cursor: "pointer",
                      zIndex: 2,
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      backgroundColor: props.userInfo && props.userInfo[props.keyName]
                        ? "#4caf50"
                        : "#efcaca",
                      borderRadius: "30px",
                      transition: "0.4s",
                    }}
                  >
                    <div
                      style={{
                        height: "4px",
                        width: "4px",
                        backgroundColor:props.userInfo && props.userInfo[props.keyName]?"#abe59b":"#f50202",
                        borderRadius: "50%",
                        position: "absolute",
                        top: "3px",
                        color:"#fff",
                        padding:"12px",
                        left: props.userInfo && props.userInfo[props.keyName]
                          ? "32px"
                          : "4px",
                        transition: "0.4s",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
  );
};

export default SwitchButton;